import type { FC, ReactNode } from 'react'
import type { FaqEntry } from '@/lib/structured-data'

import { Container } from '@/components/generals/container'

interface FaqSectionProps {
    items: FaqEntry[]
    eyebrow?: string
    heading?: string
    description?: string
}

export const FaqSection: FC<FaqSectionProps> = ({
    items,
    eyebrow = 'Frequently asked questions',
    heading = 'Questions, answered',
    description
}): ReactNode => {
    return (
        <section id='faq' className='scroll-mt-20 border-t border-border'>
            <Container className='py-16 lg:py-20'>
                <div className='max-w-2xl'>
                    <span className='text-xs font-semibold uppercase tracking-wider text-primary'>
                        {eyebrow}
                    </span>
                    <h2 className='mt-2 font-heading text-3xl font-bold tracking-tight text-foreground'>
                        {heading}
                    </h2>
                    {description && (
                        <p className='mt-3 text-[15px] leading-relaxed text-muted-foreground'>
                            {description}
                        </p>
                    )}
                </div>

                <dl className='mt-10 grid gap-4'>
                    {items.map(item => (
                        <div
                            key={item.question}
                            className='rounded-xl border border-border bg-card p-6'
                        >
                            <dt className='font-heading text-base font-semibold text-foreground'>
                                {item.question}
                            </dt>
                            <dd className='mt-2 text-[15px] leading-relaxed text-muted-foreground'>
                                {item.answer}
                            </dd>
                        </div>
                    ))}
                </dl>
            </Container>
        </section>
    )
}
